<template>
  <v-dialog v-model="dialog" width="500" content-class="class-report-dialog">
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>Question {{ questionIndex + 1 }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn flat @click="closeDialog">
            <v-icon left>close</v-icon>
            close
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text
        v-if="
          quizzes.length && questionIndex !== null && quizzes[questionIndex]
        "
      >
        <p class="question">
          <strong>Q:</strong> {{ quizzes[questionIndex].answerable.question }}
        </p>
        <p
          v-for="(a, index) in quizzes[questionIndex].answerable.answers"
          :key="index"
          class="answer"
        >
          <v-icon v-if="a.is_correct" class="icon-answer" color="correct">
            done
          </v-icon>
          <v-icon v-else class="icon-answer" color="incorrect">close</v-icon>
          {{ a.data }}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ClassQuizReportDialog',
  props: {
    dialog: {
      type: Boolean,
      require: true
    },
    questionIndex: {
      type: Number,
      require: true
    },
    quizzes: {
      type: Array,
      require: true
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:dialog', false)
    }
  }
}
</script>

<style lang="scss">
.class-report-dialog {
  .answer {
    font-size: 18px;
  }

  .question {
    font-size: 18px;
  }
}
</style>
